<section class="drive-band band--road">
  <div class="band-media" aria-hidden="true">
    <svg class="road-photo" viewBox="0 0 822 683" preserveAspectRatio="xMidYMid slice" focusable="false" role="presentation">
      <defs>
        <linearGradient id="road-car-body" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stop-color="#59616a" /><stop offset=".22" stop-color="#c4c8ce" />
          <stop offset=".55" stop-color="#e0e1e4" /><stop offset="1" stop-color="#858d97" />
        </linearGradient>
        <linearGradient id="road-car-glass" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stop-color="#192b35" /><stop offset="1" stop-color="#50626b" />
        </linearGradient>
        <g id="road-car-shape">
          <ellipse cx="1.2" cy="1.8" rx="8" ry="15" fill="#030609" opacity=".35" />
          <path d="M-7-9H7V-5H-7ZM-7 6H7V10H-7Z" fill="#14181e" />
          <path d="M-4-14Q-6-13-6-10V10Q-6 13-4 14H4Q6 13 6 10V-10Q6-13 4-14Z" fill="url(#road-car-body)" stroke="#5b636c" stroke-width=".35" />
          <path d="M-4.4-8.2Q0-9.5 4.4-8.2L3.8-3.3H-3.8Z" fill="url(#road-car-glass)" />
          <path d="M-3.8 5.8H3.8L4.3 9.2Q0 10.1-4.3 9.2Z" fill="url(#road-car-glass)" />
          <path d="M-4.8-2.6V5.2M4.8-2.6V5.2" stroke="#31414b" stroke-width=".85" />
          <rect x="-3.7" y="-2.6" width="7.4" height="7.4" rx="1.6" fill="#b9bec7" />
          <path d="M-2.8-1.6H2.8" stroke="#e9e9ed" stroke-width=".45" />
          <path d="M-2.5 3.4H2.5" stroke="#715991" stroke-width=".7" />
          <path d="M-5.8-3.4H-7M5.8-3.4H7" stroke="#a1a8b2" stroke-width="1.3" stroke-linecap="round" />
          <path d="M-4.8-12H-2.7M2.7-12H4.8" stroke="#f4eed3" stroke-width=".8" stroke-linecap="round" />
          <path d="M-4.8 11.8H-2.8M2.8 11.8H4.8" stroke="#a73642" stroke-width=".8" stroke-linecap="round" />
          <path d="M-3.5-10.5H3.5M-3.5 12.5H3.5" stroke="#858d98" stroke-width=".35" />
        </g>
      </defs>
      <image href="assets/images/background/highway-selected.png" width="822" height="683" preserveAspectRatio="xMidYMid slice" />
      <!-- Shared photo coordinates keep both cars in their lanes through the responsive crop and parallax. -->
      <g transform="translate(437 0)">
        <g class="road-car road-car--forward" transform="translate(0 342)">
          <use href="#road-car-shape" />
        </g>
      </g>
      <g transform="translate(382 0)">
        <g class="road-car road-car--reverse" transform="translate(0 342)">
          <use href="#road-car-shape" transform="rotate(180)" />
        </g>
      </g>
    </svg>
  </div>
  <div class="road-dim" aria-hidden="true"></div>
  <div class="container band-content">
    <h2
      class="band-slogan"
      [appSplitText]="'home.design.route' | translate"
      splitMode="reveal"
    ></h2>
    <p class="road-story-note" appReveal="rise" revealDelay="0.2" [revealDistance]="16">{{ 'home.design.confidenceNote' | translate }}</p>
  </div>
</section>
